import FooterCommon from './FooterCommon.jsx';

export default function FooterPet() {
  return <FooterCommon />;
}
